module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/Slice 25@2x.d9d5679f.png";